import { PrivateBankingProductCatalogueListResult } from 'pco-product-service-internal-consumer';
import { productCatalogueApi } from 'api';

export const getEligiblePrivateBankingProducts = async (
  brUid: string,
): Promise<PrivateBankingProductCatalogueListResult> => {
  return await productCatalogueApi.getEligiblePrivateBankingProductsForBr({ brUid });
};
